// Author Lin
// Date 2022-03-25 16:18:48

class SithMesInventoryStockMovement {
constructor({
        id = null,
        materialNumber = '',
        moveQuantity = '',
        sourceBin = '',
        sourceCapacity = '',
        destBin = '',
        destCapacity = '',
        operatorNumber = '',
        moveTime = '',
        credential = '',
        remark = ''}
= {}) {
    this.id = id;
    this.materialNumber = materialNumber;
    this.moveQuantity = moveQuantity;
    this.sourceBin = sourceBin;
    this.sourceCapacity = sourceCapacity;
    this.destBin = destBin;
    this.destCapacity = destCapacity;
    this.operatorNumber = operatorNumber;
    this.moveTime = moveTime;
    this.credential = credential;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryStockMovement();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'moveQuantity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.moveQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sourceBin',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.sourceBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sourceCapacity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.sourceCapacity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'destBin',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.destBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'destCapacity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.destCapacity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'operatorNumber',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.operatorNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'operatorName',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.operatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'moveTime',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.moveTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.credential',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialNumberFilter : '',
    moveQuantityFilter : '',
    sourceBinFilter : '',
    sourceCapacityFilter : '',
    destBinFilter : '',
    destCapacityFilter : '',
    operatorNumberFilter : '',
    operatorFilter : '',
    moveTimeRteFilter : '',
    moveTimeLteFilter : '',
    credentialFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'moveQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.moveQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sourceBinFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.sourceBin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sourceCapacityFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.sourceCapacity',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'destBinFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.destBin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'destCapacityFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.destCapacity',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'operatorFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.operator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'moveTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.moveTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'moveTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.moveTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'credentialFilter',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.filter.credential',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'materialNumber',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'moveQuantity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.moveQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sourceBin',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.sourceBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sourceCapacity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.sourceCapacity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'destBin',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.destBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'destCapacity',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.destCapacity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'operatorNumber',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.operatorNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'moveTime',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.moveTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.credential',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStockMovement.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryStockMovement, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
